import { useQuery } from "@tanstack/react-query";
import { usersApi } from "@/lib/humhub-api/users";

export const uploadQuotaQueryKey = ["users", "upload-quota"] as const;

export const useUploadQuota = (enabled = true) => {
  return useQuery({
    queryKey: uploadQuotaQueryKey,
    queryFn: () => usersApi.getUploadQuota(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
